<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-modal id="modal-requested-reminded" title="You have call requests" hide-footer>
    <section>
      <section>
        <p>
          The call requests that you have within the “Requested” tab are for calls that you have already approved, they are simply change requests to the date and time.
        </p>

        <p>
          No other changes have been made.
        </p>

        <p>
          There is no need to re-do any safeguarding or risk assessments when approving these requests.
        </p>
      </section>

      <section class="border-top border-bottom p-1">
<!--        <b-form-checkbox v-model="hideCheck" value="checked" unchecked-value="unchecked" @change="updateModalPreferences"-->
<!--                         class="mb-1"-->
<!--        >-->
<!--          Do not show again-->
<!--        </b-form-checkbox>-->
        <b-btn class="full-width" @click="showModal(false)" variant="primary">Close</b-btn>
      </section>
    </section>
  </b-modal>
</template>
<!-- eslint-enable -->

<script>
  import {mapState} from 'vuex';

  export default {
    components: {},
    props: {
      calls: {
        required: true,
        type: Number,
      }
    },
    data() {
      return {
        hideCheck: 'unchecked',
        localKey: 'requested-modal-key'
      };
    },
    computed: {
      ...mapState({
        prison: state => state.prison.prison,
      }),
    },
    mounted() {
      this.getModalPreferences();
      this.showModalIfAllowed();
    },
    methods: {
      showModalIfAllowed() {
        if (this.hideCheck === 'unchecked') {
          if (this.prison && !this.prison.allow_visitors_to_book && this.calls > 0) {
            this.showModal();
          }
        }
      },
      updateModalPreferences() {
        localStorage.setItem(this.localKey, this.hideCheck);
      },
      getModalPreferences() {
        const check = localStorage.getItem(this.localKey);

        if (check) {
          this.hideCheck = check;
        }

        return this.hideCheck;
      },
      showModal(value = true) {
        if (value) {
          this.$bvModal.show('modal-requested-reminded');
        } else {
          this.$bvModal.hide('modal-requested-reminded');
        }
      },
    },
  };
</script>
